S.textmedia =
  {
      elements: {
          $text: null,
      },
      init()
      {
          const list = this.elements.$text.find('p>a');

          list.each((i) =>
          {
              const classe = list.eq(i).attr('class');
              const first = list.eq(i).text();

              if (classe)
              {
                  first.replace(first.split(' ')[0], '<em class="' + classe + '">' + first.split(' ')[0] + '</em>');
                  list.eq(i).html(first.replace(first.split(' ')[0], '<em class="' + classe + '">' + first.split(' ')[0] + '</em>'));
                  list.eq(i).removeClass(classe);
              }
          });
      },
  };
